import Drupal from 'Drupal';

(function ($) {
  Drupal.behaviors.bookmarkBar = {
    attach: function (context) {
      const bookmarkBar = once(
        'bookmarkBar',
        '.paragraph--bookmark-bar',
        context,
      );
      bookmarkBar.forEach(processBookmarkBar);

      const bookmarkBarLinks = once(
        'bookmarkBarLinks',
        '.toc-list-container li a',
        context,
      );
      bookmarkBarLinks.forEach(processBookmarkBarLinks);

      function processBookmarkBar(value, index) {
        $('.toc-list-container', context).each((index, element) => {
          const $toc = $(element);
          $toc.append(getParagraphListMarkup());
        });
      }

      function processBookmarkBarLinks(value, index) {
        $(value).on('click', (event) => {
          if (value.hash !== '') {
            event.preventDefault();
            const hash = value.hash;
            $('html, body').animate(
              {
                scrollTop: $(hash).offset().top - 250,
              },
              500,
              function () {},
            );
          }
        });
      }

      function getParagraphListMarkup() {
        const $container = $('<ul></ul>');

        const $paragraphs = $(
          '.node__content > .paragraph:not(.paragraph--bookmark-bar)',
          context,
        );

        if ($paragraphs.length === 0) {
          $container.append(
            '<li>Page content is empty. Start adding some content to automatically ' +
              'populate the bookmark bar table of content list.</li>',
          );
          return $container;
        }

        $paragraphs.each((index, element) => {
          const $element = $(element);
          const text = $element.find('.paragraph__title').text();
          const url = $element.attr('id');
          $element.attr('tabindex', '-1');

          if ($element.find('.paragraph__title').length > 0) {
            $container.append(
              '<li><a href="#' + url + '">' + text + '</a></li>',
            );
          }
        });
        return $container;
      }
    },
  };
})(jQuery);
